export default __webpack_public_path__ + "static/media/youtube.5c466808.svg";